import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
 
@Injectable({

  providedIn: 'root'

})

export class PaymentService {
 
  private apiUrl = 'https://pg.zenithpay.in/payin/payins/createOrder';
 
 
  constructor(private http: HttpClient) {}
 
  createOrder(payload: any) {
    const secretKey='zug3ZTeljmyx59DLURQYX4oSHm+vQiysLnFu4jsyvJg=';
    let msg=payload.merchantId+payload.orderId+payload.payableAmount;
    const hash = CryptoJS.HmacSHA256(msg, secretKey);
    const hashcode= CryptoJS.enc.Hex.stringify(hash);
    const headers = new HttpHeaders({

      'merchantAppId': 'ZEpNIaTHy20250923123246158',

      'merchantSecretId': secretKey,
      'merchantHash':hashcode,

      'Content-Type': 'application/json'

    });
 
    return this.http.post(this.apiUrl, payload, { headers });

  }

}

 